export const FLOATING_WINDOW_BASE_Z_INDEX = 130

function isValidWindowId(windowId) {
  return typeof windowId === "string" && windowId.trim().length > 0
}

export function upsertFloatingWindowOrder(order = [], windowId) {
  if (!isValidWindowId(windowId)) return order

  const nextOrder = order.filter((entry) => entry !== windowId)
  nextOrder.push(windowId)

  if (
    nextOrder.length === order.length &&
    nextOrder.every((entry, index) => entry === order[index])
  ) {
    return order
  }

  return nextOrder
}

export function removeFloatingWindowOrder(order = [], windowId) {
  if (!isValidWindowId(windowId)) return order

  const nextOrder = order.filter((entry) => entry !== windowId)
  return nextOrder.length === order.length ? order : nextOrder
}

export function getFloatingWindowZIndex(order = [], windowId) {
  const index = order.indexOf(windowId)
  const resolvedIndex = index === -1 ? order.length : index
  return FLOATING_WINDOW_BASE_Z_INDEX + resolvedIndex
}
